import Tags from "@components/job_post/tags.tsx";
import Divider from "@sprout/divider.tsx";
import CompanyLogo from "@components/company_logo.tsx";
import "./application_form_header.scss";
import useTimeSincePublishedText from "@hooks/use_time_since_published_text.ts";

interface Props {
  title: string;
  companyName: string;
  logoUrl: string;
  publicUrl: string | undefined;
  firstPublished: string;
  locations: string[];
  workType: string | null;
  payRange: string | undefined;
}

const ApplicationFormHeader = ({
  title,
  companyName,
  logoUrl,
  publicUrl,
  locations,
  workType,
  payRange,
  firstPublished,
}: Props) => {
  const timeSincePublished = useTimeSincePublishedText(firstPublished);

  return (
    <div className={"flex flex-col gap-6"}>
      <div className={"flex flex-row justify-between"}>
        <div className={"flex flex-col gap-4 md:flex-row"}>
          <CompanyLogo companyName={companyName} logoUrl={logoUrl} size={"large"} />
          <div className={"flex flex-col justify-center items-start gap-2"}>
            <a href={publicUrl} target={"_blank"} rel="noreferrer">
              <h2 className={"application-form-header--title"}>{title}</h2>
            </a>
            <h3 className={"application-form-header--company-name"}>{companyName}</h3>
          </div>
        </div>
      </div>
      <div className={"flex flex-row justify-start"}>
        <Tags
          locations={locations}
          workType={workType}
          payRange={payRange}
          secondaryText={timeSincePublished}
        />
      </div>
      <Divider />
    </div>
  );
};

export default ApplicationFormHeader;
